module.exports = __webpack_public_path__ + "static/globalwar_mexico-aba0bfbca7264568d991b3cab99cfc45.png";